module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/new-2ad3441986c04bce3895c0d56af529ea.jpg";